export const translation = {
    category: 'Category',
    collaborator_one: 'Collaborator',
    collaborator_other: 'Collaborators',
    color: 'Color',
    column: 'Column',
    column_one: 'Column',
    column_other: 'Columns',
    schema: 'Schema',
    schema_one: 'Schema',
    schema_other: 'Schemas',
    createdIn: 'Created in',
    ranAt: 'Last run',
    dataset: 'Dataset',
    dataset_one: 'Dataset',
    dataset_other: 'Datasets',
    datasource: 'Datasource',
    description: 'Description',
    glossary: 'Glossary',
    owner: 'Owner',
    property_one: 'Property',
    property_other: 'Properties',
    usedBy: 'Used by',
    role: 'Role',
    role_one: 'Role',
    role_other: 'Roles',
    row_one: 'Row',
    row_other: 'Rows',
    shape: 'Shape',
    source: 'Source',
    source_other: 'Sources',
    source_multiple: 'Source {{number}}',
    project: 'Project',
    project_one: 'Project',
    project_other: 'Projects',
    transformation: 'Transformation',
    tags: 'Tags',
    term_one: 'Term',
    term_other: 'Terms',
    type: 'Type',
    type_other: 'Types',
    user_other: 'Users',
    warehouse: 'Warehouse',
    warehouse_other: 'Warehouses',
    snowflakeTarget: 'Snowflake Target',
    snowflakeSource: 'Snowflake Source',
    sql: 'SQL',
    sampled: 'Sampled',
    external: 'External',
    job_one: 'Job',
    week: 'Week'
};
